<template>
  <div class="listmain ">
    <h1 class="firTitle">开发者协议</h1>

    <h3 class="sedTitle">【引言】</h3>
    <p>北京猎户星空科技有限公司（以下简称“猎户”）致力于不断为用户打造更先进的人工智能技术并提供不断优化的用户体验，在此向用户提供本隐私政策，以便于用户了解和明确猎户OrionOS平台在用户访问和/或使用猎户OrionOS平台提供的服务和/或产品（下简称“服务和产品”）时对用户的信息收集和使用方式，猎户OrionOS平台充分尊重用户基于此政策做出的一切选择。
    </p>
    <p>猎户OrionOS平台在此特别提醒用户认真阅读、充分理解---本协议中各条款，包括免除或者限制猎户OrionOS平台责任的免责条款及对用户的权利限制条款。请用户审慎阅读并选择接受或不接受本协议(未成年人应在法定监护人陪同下阅读）。除非用户接受本协议所有条款，否则用户无权注册、登录或使用本协议所涉相关服务。用户注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。
    </p>
    <p>请注意：访问猎户OrionOS平台网站、使用服务和产品时，表示用户已阅读、知悉和同意接受本隐私政策。用户对本协议的接受即自愿接受全部条款的约束，包括接受猎户OrionOS平台公司对任一服务条款随时所做的任何修改。本协议可由猎户OrionOS平台随时更新，更新后的协议条款一旦公布即代替原来的协议条款，不再另行通知，用户可在猎户OrionOS平台查阅最新版协议条款。在猎户OrionOS平台修改本协议相关条款之后，如果用户不接受修改后的条款，请立即停止使用猎户OrionOS平台提供的服务；用户继续使用猎户OrionOS平台提供的服务将被视为已接受了修改后的协议。
    </p>
    <p>本政策在用户使用网站、使用服务和产品的整个过程中持续有效，若用户不同意本政策，用户应立即停止使用猎户OrionOS平台的服务或产品。
    </p>

    <h3 class="sedTitle">1. 用户使用规则</h3>
    <p>1.1 用户无需用户账户即可浏览OrionOS平台网站首页。但用户想使用猎户OrionOS平台产品、程序和服务的更多功能，用户必须注册相应账户并且于注册页面上提供相关的个人信息。用户可以按照平台说明随时终止使用用户账户，猎户OrionOS平台将会依据本协议规定保留或终止用户账户。用户必须承诺和保证：
    </p>
    <p>1.1.1 用户了解并同意，猎户OrionOS平台、软件及公众平台等服务将自动获取和使用用户在猎户OrionOS平台注册时提交的信息，用户完成注册视为已知悉并接受该行为，猎户OrionOS平台将不再以其他形式提醒用户。</p>
    <p>1.1.2 用户了解并同意，用户须对注册信息的真实性、合法性、有效性承担全部责任；用户不得冒充他人，不得利用他人的名义发布任何信息；不得恶意使用注册账户导致其他用户误认；否则猎户OrionOS平台有权立即停止提供服务，用户独自承担由此而产生的一切法律责任。</p>
    <p>1.1.3 用户应承诺：“遵守法律法规相关规定，合法使用OrionOS平台，营造和谐的积极向上的平台使用氛围。”用户使用猎户OrionOS平台产品、程序及服务的行为必须合法，用户必须为自己注册账户下的一切行为负责，包括用户所发表的任何内容以及由此产生的任何结果。用户应对其中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。猎户OrionOS平台公司无法且不会对因用户行为而导致的任何损失或损害承担责任。</p>
    <p>1.1.4 用户对用户登录信息保密、不被其他人获取并使用并且对用户在猎户OrionOS平台账户下的所有行为负责。用户必须将任何有可能触犯法律的，未授权使用或怀疑为未授权使用的行为在第一时间通知猎户OrionOS平台，猎户OrionOS平台不对因用户未能遵守上述要求而造成的任何损失承担责任。</p>
    <p>1.1.4 用户对用户登录信息保密、不被其他人获取并使用并且对用户在猎户OrionOS平台账户下的所有行为负责。用户必须将任何有可能触犯法律的，未授权使用或怀疑为未授权使用的行为在第一时间通知猎户OrionOS平台，猎户OrionOS平台不对因用户未能遵守上述要求而造成的任何损失承担责任。</p>
    <p>1.1.5 用户通过猎户OrionOS平台发表的信息为具有公开性的信息，其他第三方均可以通过猎户OrionOS平台获取用户发表的信息，用户对任何信息的发表即认可该信息为公开的信息，并单独对此行为承担法律责任；任何用户不愿被其他第三人获知的信息都不应在该平台上进行发表。</p>
    <p>1.2 用户必须知悉并确认：</p>
    <p>1.2.1 如因系统维护或升级而需要暂停网络服务，猎户OrionOS平台将尽可能通过OrionOS平台网站公告或者站内公告（站内信）或者邮件等方式事先进行通告。猎户OrionOS平台同时保留在不事先通知用户的情况下随时中断或终止部分或全部网络服务的权利，对于所有服务的中断或终止而造成的任何损失，除法律另有规定或双方另有约定外，本公司无需对用户或任何第三方承担任何责任。</p>
    <p>1.2.2 猎户OrionOS平台提供的服务中可能包括广告等活动，用户同意在使用过程中显示猎户OrionOS平台及关联方与第三方供应商、合作伙伴提供的广告以及其他活动。</p>
    <p>1.2.3 猎户OrionOS平台有权自行全权决定以任何理由，对违反有关法律法规或本协议约定；或侵犯、妨害、威胁任何人权利或安全的内容，或者假冒他人的行为，有权依法停止传输任何相关内容，并有权依其自行判断对违反本协议的任何人士采取适当的法律行动，包括但不限于，从服务中删除具有违法性、侵权性、不当性等内容，终止违反者的成员资格，阻止其使用猎户OrionOS平台全部或部分服务，并且依据法律法规保存有关信息并向有关部门报告等。</p>
    <h3 class="sedTitle">2. 用户内容</h3>
    <p>2.1 用户内容是指该用户下载、发布或以其他方式使用猎户OrionOS平台产品、程序及服务时产生的所有内容（例如：用户信息、图片、音乐或其他内容）；用户是用户内容唯一的责任人，用户将承担因用户内容自行公开而导致的用户或任何第三方被识别的风险。</p>
    <p>2.2 用户通过上传、发行或其他方式使用用户在猎户OrionOS平台产品、程序及服务的用户内容时，即视为自动授权且承诺和保证用户有权授权给猎户OrionOS平台不可撤销的、非独家的、免版税的且足额缴纳的全球许可，用以：</p>
    <p>2.2.1 仅为向用户提供猎户OrionOS平台产品和程序服务或改进猎户OrionOS平台产品、程序及服务之目的，复制、发行、公开展示和表演、制作衍生作品、将其纳入其他作品或以其他方式使用用户账户（排除用户个人信息）；并授予上述事项的转让许可；
    </p>
    <p>2.2.2 仅为向目标接收者提供个人信息之目的，复制、发行用户内容中的私人信息；
    </p>
    <p>2.2.3 用户同意不可撤销的、放弃的（并会导致被放弃）关于用户内容的道德权利和归属的声明。
    </p>
    <h3 class="sedTitle">3. 用户权利及义务</h3>
    <p>3.1 合法使用猎户OrionOS平台的权利；
    </p>
    <p>3.2 在用户所有的移动通信设备上下载、安装、使用猎户OrionOS平台产品、程序及服务的权利；
    </p>
    <p>3.3 猎户OrionOS平台帐号的所有权归猎户OrionOS平台及其关联公司所有，基于帐号安全性的考虑，禁止使用他人的手机号、邮箱地址注册猎户OrionOS平台帐号。用户完成申请注册手续后，获得猎户OrionOS平台帐号的使用权，该使用权仅属于初始申请注册人，禁止赠与、借用、租用、转让或售卖。猎户OrionOS平台因经营需要，有权回收用户的帐号。如因使用他人手机号、邮箱地址注册或赠与、借用、租用等转让账号行为，损害第三人权利，猎户OrionOS平台不承担任何责任；
    </p>
    <p>3.4 用户有权更改、删除在猎户OrionOS平台上的个人资料、注册信息及发布内容等，但需注意，删除有关信息的同时也会删除任何用户储存在系统中的文字和图片。用户需承担该风险；
    </p>
     <p>3.5 用户有责任妥善保管注册账户信息及账户密码的安全，用户需要对注册帐户以及密码下的行为承担法律责任。用户同意在任何情况下不使用其他成员的账户或密码。在用户怀疑他人在使用用户账户或密码时，用户同意立即通知猎户OrionOS平台。
    </p>
    <p>3.6 权利限制：
    </p>
    <p>3.6.1 用户不得对猎户OrionOS平台内容或猎户OrionOS平台产品、程序及服务（包括但不限于内容或产品中的广告或赞助内容）进行任何形式的许可、出售、租赁、转让、发行或做其他商业用途；
    </p>
    <p>3.6.2 用户不得以创建相同或竞争服务为目的访问猎户OrionOS平台或使用猎户OrionOS平台产品、程序及服务；
    </p>
    <p>3.6.3 除非法律明文规定，否则用户不得对猎户OrionOS平台或猎户OrionOS平台产品、程序及服务（包括但不限于内容或产品中的广告或赞助内容）的任何部分以任何形式或方法进行复制、发行、再版、下载、显示、张贴、修改、翻译、合并、利用、分解或反向编译等；
    </p>
    <p>3.6.4 用户已同意通过上传、发布或以其他方式使用猎户OrionOS平台或猎户OrionOS平台产品、程序和服务，在使用过程中，用户将承担因下述行为所造成的风险而产生的全部法律责任：破坏宪法所确定的基本原则的；危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一的;损害国家荣誉和利益的；煽动民族仇恨、民族歧视，破坏民族团结的；破坏国家宗教政策，宣扬邪教和封建迷信的；散布谣言，扰乱社会秩序，破坏社会稳定的；散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；侮辱或者诽谤他人，侵害他人合法权益的；含有法律法规、行政规章所禁止的其他内容的。
    </p>
    <p>3.6.5 用户已同意不在猎户OrionOS平台或利用猎户OrionOS平台产品、程序及服务从事下列行为：上传或发布电脑病毒、蠕虫、恶意代码、故意破坏或改变计算机系统或数据的软件；未授权的情况下，收集其他用户的信息或数据，例如电子邮箱地址等；
    </p>
    <p>3.6.6 禁用猎户OrionOS平台的网络连接，给猎户OrionOS平台造成过度的负担或以其他方式干扰或损害平台服务器和网络链接；在未授权的情况下，尝试访问猎户OrionOS平台、服务器或猎户OrionOS平台的网络链接；
    </p>
    <p>3.6.7 干扰、破坏其它用户正常使用猎户OrionOS平台或猎户OrionOS平台产品、程序及服务。
    </p>
    <h3 class="sedTitle">4. 隐私条款</h3>
     <p>4.1 猎户OrionOS平台可能收集的信息
    </p>
     <p>4.1.1 用户在访问猎户OrionOS平台的官方网站时，猎户OrionOS平台可能收集如下用户信息，用于有效管理网站、分析站内活动和提升服务：
    </p>
     <p>• 使用cookie技术在用户设备，储存和分析用户的浏览信息和活动记录，向用户提供个性化的服务。
    </p>
     <p>4.1.2 用户在注册和使用服务和产品过程中，猎户OrionOS平台可能收集如下用户信息，用于管理用户账户、满足用户的使用需求、提升服务和产品质量以及猎户OrionOS平台的技术能力：
    </p>

     <p>• 用户的个人信息：包括但不限于真实姓名、职业、地址、电子邮件、手机号码、设备号、证件号码、用户账户信息、支付信息等。
    </p>

     <p>• 用户的企业信息：包括但不限于企业名称、企业证件和号码、企业负责人及其联系方式、企业经营范围、企业终端客户等。
    </p>

    <p>• 用户在使用服务和产品过程中，用户以各种方式自动提供的各种类型的信息（包括但不限于文字、符号、数字、图片、音频、视频等）。
    </p>

    <p>• 猎户OrionOS平台可能会将用户通过自己的账户提交的信息与猎户OrionOS平台的其他服务或第三方的信息相结合，以便为用户提供更好的体验并提高猎户OrionOS平台的服务质量。
    </p>

    <p>• 其它因用户登入猎户OrionOS平台网站、使用服务和产品而使 猎户OrionOS平台直接或间接获得或有权利获得的一切信息。
    </p>

    <p>• 猎户OrionOS平台的产品和服务中可能含有第三方产品和/或服务的链接或信息。如果用户将个人信息填写在其他平台上或通过第三方程序提交/发布，则该方可能会获知用户信息。该第三方应用程序可能有其相应的隐私政策规定，请仔细查看，并在提供个人信息前请仔细考虑清楚。本隐私政策不适用于第三方向用户收集信息的行为，猎户OrionOS平台无法控制第三方的行为，因此也不会对第三方收集、使用用户信息的行为承担责任。
    </p>

    <p>4.1.3 用户在此明确，其因访问猎户OrionOS平台网站、使用服务和产品时所提供的一切信息数据均包含在上述猎户OrionOS平台可能收集的信息数据范围内（下简称“信息数据”）。
    </p>

    <p>4.1.4 猎户OrionOS平台将严格遵守有关法律法规和本隐私政策所载明的内容收集、使用用户信息。除非持有猎户OrionOS平台官方出具的授权文件，否则猎户OrionOS平台的具体工作人员不会直接向用户索要个人信息。如遇此类情况，用户可以直接与猎户OrionOS平台联系。
    </p>

     <p>4.2 猎户OrionOS平台对信息的披露
    </p>

     <p>4.2.1 除非法律法规规定、政府部门要求或本隐私政策载明的例外情况，猎户OrionOS平台会妥善保存用户信息，不予泄露。
    </p>

     <p>4.2.2 用户于此授权，在以下情形中，猎户OrionOS平台可以向第三方披露用户信息而无需再行获得用户同意：
    </p>

     <p>• 如果猎户OrionOS平台披露这些信息是用来识别、联系或向可能对猎户OrionOS平台的权利或财产、平台用户或者其他任何人（包括其他任何人的权利和财产）造成损害之行为提起诉讼之必要；
    </p>

     <p>• 猎户OrionOS平台将个人信息提供给猎户OrionOS平台的关联方或其他有合作关系的企业或个人，以便其代表/协助猎户OrionOS平台处理这些信息。猎户OrionOS平台要求上述各方同意按照猎户OrionOS平台的规定、本隐私政策以及有关法律法规之规定来处理这些信息。
    </p>

    <p>4.3 猎户OrionOS平台对信息的合理使用
    </p>

    <p>4.3.1 猎户OrionOS平台在获得用户同意的前提下，有权合理使用用户和第三方通过用户平台而使用服务和产品时所提供的一切信息数据。
    </p>

    <p>4.3.2 猎户OrionOS平台有权为公司发展之目的而使用信息数据，其使用方式包括但不限于：
    </p>

    <p>• 纳入猎户OrionOS平台现有的且不断更新和扩充的数据库；
    </p>

    <p>• 结合猎户OrionOS平台现存的和未来不断研发的技能，对信息进行存储、分类、归纳、组合、运算、分析、总结等各种方式予以信息处理；
    </p>

    <p>• 使用猎户OrionOS平台现存的和未来不断研发的技能，使用信息数据提升服务和产品的质量，对猎户OrionOS平台的人工智能技术和产品进一步研发、深度学习、测试和运维。
    </p>

    <p>4.3.3 猎户OrionOS平台对本公司运营的合法性和合规性负责，有权对被投诉、举报和猎户OrionOS平台自主审查时发现的可能侵犯第三方合法权益或公共利益的争议信息，进行主动或根据政府机关、司法机关、监察机构、权利方的要求而对信息数据进行查询、识别、删除和其它根据猎户OrionOS平台现有的和未来不时修订的公司政策和规章制度以及国家法律法规采取的合理措施。
    </p>

     <p>4.3.4 猎户OrionOS平台在与第三方进行商业合作以及第三方因使用猎户OrionOS开放平台的过程中，猎户OrionOS平台因使用和分析第三方及其终端客户所提供的信息数据而可能生成的研究报告等作品，猎户OrionOS平台对该等作品享有完整和独立的知识产权。
    </p>

     <p>4.4 信息安全
    </p>

     <p>4.4.1 猎户OrionOS平台将采取必要的技术手段，保证用户可以访问、更新、更正、删除用户的账户信息和个人信息，在用户采取前述操作时，猎户OrionOS平台可能会要求用户进行身份验证，以保证用户账户信息安全。
    </p>

      <p>4.4.2 用户应妥善披露和保管用户的账户信息以及能够对用户进行个人辨识或涉及个人通信的敏感信息，避免向不必要的第三方披露前述敏感信息。若用户账户信息发生泄露，用户应及时通过猎户OrionOS平台公布在官网首页的联系方式联络猎户OrionOS平台，以便 猎户OrionOS平台配合用户采取相应的用户保护措施。
    </p>

      <p>4.4.3 猎户OrionOS平台将尽合理的努力保障用户的信息安全。用户应知晓并理解：由于现有技术的限制和可能存在的各种恶意手段，在互联网上，即便猎户OrionOS平台尽到了合理的注意义务和采取了规范的措施，也不可能始终保证信息数据百分之百的安全。用户应了解，在用户接入其服务系统和通讯网络时，随时可能因猎户OrionOS平台可控范围外的因素而出现信息安全问题，该风险由用户自行承担。因此，猎户OrionOS平台对隐私信息的维护或保密无法做出任何确定性的保证或承诺。如果猎户OrionOS平台知悉其所获取并储存的数据安全受到危害或由于外部行为（包括但不限于外部安全攻击）使用户的非公开信息被披露给不相关第三方，尽管本政策中有其它免责规定，猎户OrionOS平台仍将采取其认为适当的合理措施（包括但不限于内部调查、上报并通知执法机构、以及配合执法机构工作等）。同时，猎户OrionOS平台也会在其认为适当的情况下采取合法合理措施通知相关用户，告知其被披露的信息以及猎户OrionOS平台对该信息的知悉程度。
    </p>

      <p>4.4.4 猎户OrionOS平台会采取必要手段、努力防止内部工作人员越权获取/利用/泄露用户信息。
    </p>

      <p>4.5 未成年人的隐私保护
    </p>

      <p>4.5.1 猎户OrionOS平台承诺利用现有的、未来可能新增的技术手段，对猎户OrionOS平台网站、服务和产品中由猎户OrionOS平台所提供的信息数据进行安全化处理，尽最大努力排除非法的、不符合社会公益和安全的信息数据。
    </p>

    <p>
4.5.2 未成年人应在其监护人的陪同下仔细阅读本隐私政策，并在提交的个人信息之前寻求监护人的同意和指导。监护人应承担未成年人在网络环境下隐私保护的首要责任。
    </p>

    <p>
   4.5.3 监护人有权根据猎户OrionOS平台网站首页明示的联系方式，书面要求猎户OrionOS平台配合监护人进行如下操作：   
    </p>

    <p>
      • 变更、删除未成年人的账户信息；
    </p>

    <p>
      • 其它猎户OrionOS平台根据法律法规和行业规范，认为合理的要求。
    </p>

    <p>
      4.6 虽本隐私声明说明了猎户OrionOS平台在保护隐私方面所遵循的标准，但这些标准可能会发生变化。如猎户后续对本隐私政策进行修订，该修订构成本隐私政策的一部分。猎户会在猎户OrionOS平台网站上发布对本隐私政策所做的任何变更。若用户继续使用猎户的产品和/或服务，即表示用户同意修订后的本隐私政策的约束。如果用户不接受修改后的条款，请立即停止使用猎户OrionOS平台提供的服务。
    </p>

    <h3 class="sedTitle">5. 第三方</h3>
    <p>5.1 用户已知晓本协议是在用户与猎户OrionOS平台之间签订，而非用户与上述第三方之间签订。猎户OrionOS平台是猎户OrionOS平台产品、程序及服务所产生的内容、维护、支持服务、保证和由此产生的诉讼等事项的唯一责任人。用户已同意遵守且授权给猎户OrionOS平台和猎户OrionOS平台产品、程序及服务限制用户有条件的使用猎户OrionOS平台的服务。
    </p>
     <p>5.2 用户需对用户使用第三方平台和广告产生的风险承担法律责任。当用户访问第三方平台和广告时，适用第三方的条款和政策。
    </p>

     <p>5.3 猎户OrionOS平台和猎户OrionOS平台产品、程序及服务包含其他用户提供的用户内容。用户与其他用户的互动仅属于用户与其他用户之间的行为，猎户OrionOS平台不控制且不对以上用户内容承担法律责任，也没有检查、监控、审批、核准以上用户内容的义务。用户对因使用该用户内容以及与其他用户互动产生的风险承担法律责任。猎户OrionOS平台和猎户OrionOS平台产品、程序及服务对此类行为不承担任何法律责任。
    </p>

     <p>5.4 猎户OrionOS平台可能与第三方进行合作和/或聘用第三方为猎户OrionOS平台提供必要的技术支持、维护和服务，在此情况下，该第三方仅为履行协议之必要而接触有限的信息数据，且已与猎户OrionOS平台签署必要的条款以保护信息数据。
    </p>
 <h3 class="sedTitle">6. 损害赔偿</h3>
 <p>6.1 用户已同意无害的使用猎户OrionOS平台和猎户OrionOS平台产品、程序及服务，避免猎户OrionOS平台因下述行为或相关行为遭受来自第三方的任何投诉、诉讼、损失、损害、责任、成本和费用（包括但不限于律师费）：用户使用猎户OrionOS平台和猎户OrionOS平台产品、程序及服务的行为；用户内容；用户违反本协议的行为。
 </p>

 <p>6.2 用户内容是指该用户下载、发布或以其他方式使用猎户OrionOS平台产品、程序及服务时产生的所有内容（例如：用户信息、图片、音乐或其他内容）；用户是用户内容唯一的责任人，用户将承担因用户内容自行公开而导致的用户或任何第三方被识别的风险。
 </p>

 <p>6.3 用户已同意，除非获得猎户OrionOS平台书面同意，用户不得在用户与猎户OrionOS平台共同对第三方提起的诉讼中单方和解。
 </p>

 <p>6.4 猎户OrionOS平台将尽合理努力将此类诉讼、诉讼行为或进程通知用户。
 </p>

 <p>6.5 在任何情况下，猎户OrionOS平台都不对用户或任何第三方因本协议产生的任何间接性、后果性、惩戒性的、偶然的、特殊或惩罚性的损害赔偿承担责任。访问、使用猎户OrionOS平台和猎户OrionOS平台产品、程序及服务所产生的损坏计算机系统或移动通讯设备数据库的风险将由用户个人承担。
 </p>


    <h3 class="sedTitle">7. 免责声明</h3>

 <p>7.1 如发生下述情形，猎户OrionOS平台不承担任何法律责任：
 </p>

 <p>7.1.1 依据法律规定或相关政府部门的要求提供用户个人信息；
 </p>

 <p>7.1.2 由于用户使用不当或其他自身原因而导致任何个人信息的泄露；
 </p>

 <p>7.1.3 任何由于黑客攻击，电脑病毒的侵入，非法内容信息、骚扰信息的屏蔽，政府管制以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断、受阻等不能满足用户要求的情形；
 </p>

 <p>7.1.4 用户因第三方如运营商的通讯线路故障、技术问题、网络、电脑故障、系统不稳定及其他因不可抗力造成的损失的情形； 使用猎户OrionOS平台产品、程序及服务可能存在的来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息而招致的风险；
 </p>

 <p>7.1.5 用户之间通过猎户OrionOS平台或猎户OrionOS平台产品、程序及服务与其他用户交往，因受误导或欺骗而导致或可能导致的任何心理、生理上的伤害以及经济上的损失；
 </p>

 <p>7.1.6 猎户OrionOS平台和猎户OrionOS平台产品、程序及服务明文声明，不以明示、默示或以任何形式对猎户OrionOS平台及其合作公司服务之及时性、安全性、准确性做出担保。
 </p>

 <p>7.2 用户在猎户OrionOS平台所发布的任何内容并不代表和反映猎户OrionOS平台的任何观点或政策，用户因在猎户OrionOS平台发表和反映内容陷入纠纷的，一切责任由用户本人承担，猎户OrionOS平台对此不承担任何责任。
 </p>

 <p>7.3 在任何情况下，猎户OrionOS平台均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因用户使用猎户OrionOS平台服务而遭受的利润损失，承担责任。尽管本协议中可能含有相悖的规定，猎户OrionOS平台对用户承担的全部责任，无论因何原因或何种行为方式，始终不超过用户在注册期内因使用猎户OrionOS平台服务而支付给猎户OrionOS平台的费用(如有)。
 </p>


    <h3 class="sedTitle">8. 知识产权</h3>
    <p>8.1 用户在猎户OrionOS平台或互动平台上发布的信息不得侵犯任何第三人的知识产权，未经具有相关所有权所有者之事先书面同意，用户不得以任何方式上传、发布、修改、传播或复制任何受著作权保护的材料、商标或属于其他人的专有信息。如果收到任何著作权人或其合法代表发给猎户OrionOS平台的适当通知后，猎户OrionOS平台将在审查的基础上移除该等侵犯他人著作权的内容。
    </p>

    <p>8.2 猎户OrionOS平台服务中所涉及的猎户OrionOS平台标志及产品、服务名称，均为猎户OrionOS平台之商标。未经猎户OrionOS平台事先书面同意，用户不得将猎户OrionOS平台标识以任何方式展示或使用或作其他处理，任何单位及个人不得以任何方式或理由对该商标的任何部分进行使用、复制、修改、传播、抄录或与其它产品捆绑使用销售。
    </p>

    <p>8.3 除前述规定以外，如果用户认为有人复制并在猎户OrionOS平台服务上发布用户作品，并已构成对用户著作权的侵犯，请及时与猎户OrionOS平台联系，提供包含如下信息的书面通知：
    </p>

    <p>8.3.1 证明用户作为涉嫌侵权内容所有者的权属证明；
    </p>

    <p>8.3.2 明确的身份证明、住址、联系方式；
    </p>

     <p>8.3.3 涉嫌侵权内容在猎户OrionOS平台服务上的位置；
    </p>

     <p>8.3.4 用户声称遭受侵犯的著作权作品的描述；
    </p>

     <p>8.3.5 用户著作权遭受侵犯的相关证明；
    </p>

     <p>8.3.6 在同意承担伪证处罚之后果的前提下，出具书面陈述以声明用户在通知中所述内容是准确和真实的。
    </p>

     <p>请您把以上资料和联络方式书面发往以下地址：
    </p>
    <p>
      北京市朝阳区工体路盈科中心C座
    </p>
     <p>
      北京猎户星空科技有限公司 法务部
    </p>
     <p>
      邮政编码：100000
    </p>
        <h3 class="sedTitle">9. 修改与终止</h3>
        <p>
          9.1 修改
        </p>
        <p>
9.1.1 本协议容许变更。本协议可由猎户OrionOS平台随时更新，更新后的协议条款一旦公布即代替原来的协议条款，不再另行通知，用户可在猎户OrionOS平台查阅最新版协议条款。变更通知之后，继续使用猎户OrionOS平台和猎户OrionOS平台产品、程序及服务则视为用户已知晓此类变更并同意受条款其约束；
        </p>

         <p>
          9.1.2 猎户OrionOS平台保留在任何时候无需通知而修改、保留或关闭猎户OrionOS平台、猎户OrionOS平台产品、程序或任何服务之权利；
        </p>

         <p>
          9.1.3 用户已同意，除法律另有规定或双方另有约定，猎户OrionOS平台无需因修改、保留或关闭猎户OrionOS平台、猎户OrionOS平台产品、程序或其他服务的行为对用户或第三方承担责任。
        </p>

         <p>
          9.2 终止
        </p>

         <p>9.2.1 本协议自用户接受之日起生效，在用户使用猎户OrionOS平台和猎户OrionOS平台产品、程序及服务的过程中持续有效，直至依据本协议终止；
        </p>
         
         <p>9.2.2 尽管有上述规定，如果用户使用猎户OrionOS平台和猎户OrionOS平台产品、程序及服务的时间早于用户接受本协议的时间，用户在此知晓或应当知晓并同意本协议于用户第一次使用猎户OrionOS平台和猎户OrionOS平台产品、程序及服务时生效，除非依据本协议提前终止。
        </p>
         
         <p>9.3 猎户OrionOS平台可能会：依据法律的规定，保留用户使用猎户OrionOS平台、猎户OrionOS平台产品、程序及服务、或者猎户OrionOS平台账户的权利；无论是否通知，猎户OrionOS平台将在任何时间以任何原因终止本协议，包括出于善意的相信用户违反了猎户OrionOS平台可接受使用政策或本协议的其他规定。终止本协议的最终解释权归猎户OrionOS平台所有。
        </p>
         
         <p>9.4 不受前款规定所限，如果用户侵犯第三人的版权且猎户OrionOS平台接到版权所有人或版权所有人的合法代理人的通知后，猎户OrionOS平台保留终止本协议的权利。
        </p>
         
         <p>9.5 一旦本协议终止，用户平台账户和使用猎户OrionOS平台和猎户OrionOS平台产品、程序及服务的权利即告终止。用户应当知晓且同意用户平台账户终止意味着用户内容将从猎户OrionOS平台的活动数据库中删除。猎户OrionOS平台不因终止本协议对用户承担任何责任，包括终止用户账户和删除用户内容。
        </p>

        <p>9.6 任何猎户OrionOS平台的更新版本或猎户OrionOS平台产品、程序及服务的未来版本、更新或者其他变更将受到本协议约束。
        </p>
        <h3 class="sedTitle">10.其他</h3>
        <p>10.1 反馈
        </p>
         <p>10.1.1 用户对猎户OrionOS平台提出建议（或称“反馈”），即视为用户向猎户OrionOS平台转让“反馈”的全部权利并同意猎户OrionOS平台有权利以任何合理方式使用此反馈及其相关信息。猎户OrionOS平台将视此类反馈信息为非保密且非专有；
        </p>
         
          <p>10.1.2 用户已同意用户不会向猎户OrionOS平台提供任何用户视为保密和专有的信息。
        </p>
         <p>10.2 通知
        </p>
          <p>10.2.1 用户必须提供用户最近经常使用的有效的电子邮件地址。用户所提供的电子邮件地址无法使用或者因任何原因猎户OrionOS平台无法将通知送达给用户而产生的风险，猎户OrionOS平台不承担责任。猎户OrionOS平台发布的公告通知及向用户所发送的包含此类通知的电子邮件毫无疑问构成有效通知。
        </p>
          <p>10.3 适用法律
        </p>
          <p>10.3.1 本协议适用中华人民共和国法律。
        </p>
          <p>10.3.2 如果双方发生纠纷，应本着友好的原则协商解决；如协商不成，应由北京猎户星空科技有限公司住所地法院管辖。
        </p>
          <p>10.4 独立性
        </p>
          <p>10.4.1 若本协议中的某些条款因故无法适用，则本协议的其他条款继续适用且无法适用的条款将会被修改，以便其能够依法适用。
        </p>
       

  </div>
</template>

<script>
  export default {
    name: ""
  };

</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }

  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle {
      margin-top: 50px;
      font-weight: bold;
      line-height: 26px;
    }
    .codeTitle {
      font-weight: bold;
      line-height: 26px;
    }
    pre {
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      border-collapse: collapse;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/components/tutor/kfzxy.vue